<div style="padding: 24px;">
    <div style="max-height:260px;padding-bottom:0px;margin-bottom:0px">
        <div class="row">
            <h5 class="form-heading" *ngIf="!isOTPSendSuccessfully==true" style="text-align:center">Reset Password</h5>

        </div>

        <h4 class=" text-center alert alert-success text-center" *ngIf="isOTPSendSuccessfully==true">Please check your E-mail</h4>
        <img *ngIf="isOTPSendSuccessfully==true" src="assets/download.jpg" style="width:150px;height:180px;margin-left:50px">
        <form [formGroup]="password_form" *ngIf="!isOTPSendSuccessfully==true">
            <div class="row form-group">
                <div class="col-lg-12">
                    <mat-form-field floatLabel="always">
                        <mat-label>Login Id</mat-label>
                        <input name="nodes" class="w-93" formControlName="login_id" matInput placeholder="Enter Login Id" [required]="password_form.value.login_id!=null">

                    </mat-form-field>
                    <small class="form-text text-muted" *ngIf="password_form.controls.login_id.touched && password_form.controls.login_id.errors?.required">
                        <p style="color: red">Please enter Login id</p>
                    </small>


                </div>
            </div>

            <div class="row">

                <div class="col-md-12">
                    <button class="float-right ml-1 btn btn-sm btn-info" style="width: 60%;" (click)="save()">
                        Find My Account?
                    </button>

                </div>
            </div>
        </form>
    </div>
</div>